import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'
import { withTranslation } from 'react-i18next'
import { Input } from 'reactstrap'

import { getDateRange } from '../../reducers/dateRange'
import { updatePeriod } from '../../actions/dateRange'

const DateRangePeriodGlobal = ({ dispatch, dateRange, t }) => (
  <Input
    id="period"
    type="select"
    value={dateRange.period}
    onChange={(e) => dispatch(updatePeriod(e.target.value))}
  >
    <option value="DATE_RANGE_LAST_MONTH">{t('header.daterange.lastMonth')}</option>
    <option value="DATE_RANGE_LAST_3_MONTHS">{t('header.daterange.last3months')}</option>
    <option value="DATE_RANGE_LAST_6_MONTHS">{t('header.daterange.last6months')}</option>
    <option value="DATE_RANGE_LAST_12_MONTHS">{t('header.daterange.last12months')}</option>
    <option value="DATE_RANGE_THIS_YEAR">{t('header.daterange.thisYear')}</option>
    <option value="DATE_RANGE_LAST_YEAR">{t('header.daterange.lastYear')}</option>
    <option value="DATE_RANGE_CUSTOM">{t('header.daterange.custom')}</option>
  </Input>
)

const mapStateToProps = (state) => ({
  dateRange: getDateRange(state),
})

DateRangePeriodGlobal.propTypes = {
  dispatch: PropTypes.func.isRequired,
  dateRange: PropTypes.object.isRequired,
}

export default withTranslation()(connect(mapStateToProps)(DateRangePeriodGlobal))
